<template>
  <section class="steps-main">
    <div class="steps-main__bg"></div>
    <div class="steps-main__content">
      <div class="step-head">
        <div class="container">
          <div class="head-row">
            <div class="head-row__position">
              <i18n path="forms.formHeader" tag="h2">
                <span>{{ this.$i18n.t("bank.step") }}</span>
              </i18n>
            </div>
            <h1>{{ this.$i18n.t("bank.stepDescription") }}</h1>
            <img src="@/assets/head-paso3.svg" class="head-row__img" />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="box-form">
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="12" xs="12" sm="12" md="12" lg="10" xl="10">
              <v-form ref="form" v-model="valid" @submit.prevent="saveBankInfo">
                <div class="row-form">
                  <div class="col-form col-form--full">
                    <h3>{{ this.$i18n.t("bank.guide") }}</h3>
                  </div>
                  <div class="col-form">
                    <div class="col-form__item col-form__item--select">
                      <label>{{ this.$i18n.t("bank.fundOrigin") }}</label>
                      <v-autocomplete v-model="fund_origin" :rules="fundOriginRules" :items="fund_origins" item-text="type" item-value="code" required id="bank-fund-origin"></v-autocomplete>
                    </div>
                  </div>
                  <div class="col-form">
                    <div class="col-form__item col-form__item--select">
                      <label>{{ this.$i18n.t("bank.bank") }}</label>
                      <v-autocomplete v-model="bank_name" :rules="bankNameRules" :items="bank_names" item-text="name" item-value="code" required id="bank-bank-name"></v-autocomplete>
                    </div>
                  </div>
                  <div class="col-form">
                    <div class="col-form__item col-form__item--select">
                      <label>{{ this.$i18n.t("bank.accountType") }}</label>
                      <v-autocomplete v-model="bank_account_type" :rules="bankAccountTypesRules" :items="bank_account_types" item-text="type" item-value="code" required id="bank-account-type"></v-autocomplete>
                    </div>
                  </div>
                  <div class="col-form">
                    <div class="col-form__item">
                      <label>{{ this.$i18n.t("bank.accountNumber") }}</label>
                      <v-text-field id="bank-account" v-model="bank_account" :rules="bankAccountRules" required autocomplete="off"></v-text-field>
                    </div>
                  </div>
                </div>
                <div class="box-btns">
                  <v-btn class="btn-finish" color="primary" :loading="loading" :disabled="!valid || loading" type="submit" id="bank-submit-button">{{ this.$i18n.t("bank.buttonContinue") }}</v-btn>
                </div>
              </v-form>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </div>
      </div>
      <v-dialog v-model="savingDialog" persistent width="300">
        <v-card color="primary" dark>
          <div class="ma-2">
            <v-card-text>
              <p>{{ this.$i18n.t("bank.saving") }}</p>
              <v-progress-linear indeterminate color="white"></v-progress-linear>
            </v-card-text>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="errorDialog" width="300">
        <v-card>
          <v-card-text>
            <div class="box-photo text-alert">
              <v-icon color="primary">mdi-alert-circle-outline</v-icon>
              <p>{{ errorMessage }}</p>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="errorDialog = false">{{ this.$i18n.t("errors.button") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </section>
</template>

<script>
/* eslint-disable arrow-parens, operator-linebreak, implicit-arrow-linebreak */
import { bankSelects } from "@/mixins/bankSelects";

export default {
  name: "BankForm",
  mixins: [bankSelects],
  data() {
    return {
      errorDialog: false,
      errorMessage: this.$i18n.t("errors.default"),
      savingDialog: false,
      valid: false,
      loading: false,
      fund_origin: null,
      bank_name: null,
      bank_account_type: null,
      bank_account: null,
      fundOriginRules: [v => !!v || this.$i18n.t("forms.formMustComplete"), v => this.fund_origins.some(el => el.code === v) || this.$i18n.t("forms.formGeneric")],
      bankNameRules: [v => !!v || this.$i18n.t("forms.formMustComplete"), v => this.bank_names.some(el => el.code === v) || this.$i18n.t("forms.formGeneric")],
      bankAccountTypesRules: [v => !!v || this.$i18n.t("forms.formMustComplete"), v => this.bank_account_types.some(el => el.code === v) || this.$i18n.t("forms.formGeneric")],
      bankAccountRules: [v => !!v || this.$i18n.t("forms.formMustComplete")],
    };
  },
  methods: {
    async saveBankInfo() {
      this.loading = true;
      this.savingDialog = true;
      const jsonSend = {
        email: this.$store.state.email,
        session: this.$store.state.session,
        fund_origin: this.fund_origin,
        bank_name: this.bank_name,
        bank_account_type: this.bank_account_type,
        bank_account: this.bank_account,
      };
      try {
        const response = await this.axios.post(`${process.env.VUE_APP_BACKEND}bank`, jsonSend, {
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
        });
        if (response.data.code !== 200) {
          this.savingDialog = false;
          this.errorDialog = true;
          this.loading = false;
          return;
        }
        this.$store.commit("updateName", { name: response.data.name, family_name: response.data.family_name });
        this.$store.commit("updateFormStep", { step: 7 });
        this.$router.push("success");
      } catch {
        this.savingDialog = false;
        this.errorDialog = true;
        this.loading = false;
      }
    },
  },
  mounted() {},
};
</script>

<style></style>
